export function taskStatusKey(task) {
    if (!task) {
        return "pending";
    }
    if (Number(task.archived) === 1) {
        return "archived";
    }
    if (task.completed_at) {
        return "completed";
    }
    if (task.tasks_boards_id || task.tasks_boards_columns_id) {
        return "in_progress";
    }
    return "pending";
}

export function taskStatusChipColor(statusKey) {
    switch (statusKey) {
        case "completed":
            return "success";
        case "in_progress":
            return "primary";
        case "archived":
            return "muted";
        default:
            return "default";
    }
}

export function taskPriorityKey(priority) {
    const value = Number(priority);
    if (value >= 3) {
        return "high";
    }
    if (value === 2) {
        return "medium";
    }
    if (value === 1) {
        return "low";
    }
    return "undefined";
}

export function taskPriorityChipColor(priorityKey) {
    switch (priorityKey) {
        case "high":
            return "error";
        case "medium":
            return "warning";
        case "low":
            return "muted";
        default:
            return "default";
    }
}

export function taskPriorityFlagTone(priority) {
    switch (taskPriorityKey(priority)) {
        case "high":
            return "high";
        case "medium":
            return "medium";
        case "low":
            return "low";
        default:
            return "undefined";
    }
}

export function taskAssigneeInitials(name) {
    if (!name || typeof name !== "string") {
        return "?";
    }
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) {
        return "?";
    }
    const first = parts[0].charAt(0);
    const second = parts.length > 1 ? parts[1].charAt(0) : "";
    return (first + second).toUpperCase();
}

export function taskGroupLabel(task) {
    if (!task) {
        return "";
    }
    if (task.board_name && task.column_name) {
        return task.board_name + " · " + task.column_name;
    }
    return task.board_name || task.column_name || "";
}

export function taskClientName(task) {
    if (!task) {
        return "";
    }
    if (task.client && (task.client.first_name || task.client.last_name)) {
        return [task.client.first_name, task.client.last_name]
            .filter(Boolean)
            .join(" ")
            .trim();
    }
    if (task.client_name) {
        return task.client_name;
    }
    return [task.first_name, task.last_name].filter(Boolean).join(" ").trim();
}
